import React from "react";

//PODS
//--ADMIN
import HVSAdminLoginControl from "./administration/HVSLoginForm/loginControl";
import WebsiteQuoteAdmin from "./websiteQuote/admin/podRouter";
import AppRequestQuoteAdmin from "./appRequestQuote/admin/podRouter";
import ViewHelp_HelpDesk from "./viewHelp/admin/podRouter";
import ViewHelp_OnlinePayments from "./viewHelp/onlinePayments/admin/podRouter";
import CalendarAdmin from "./calendar/admin/podRouter";
import PlannerAdmin from "./planner/admin/podRouter";
import PodCastsAdmin from "./podCasts/admin/podRouter";
import BlogsAdmin from "./blogs/admin/podRouter";
import FootballAPIAdmin from "./footballAPI/admin/files/controller";
import PhotoGalleryAdmin from "./photoGallery/admin/podRouter";

//--FRONTEND
import WebsiteQuoteFrontEnd from "./websiteQuote/frontEnd/files/quoteSystem";
import MembershipExtra from "./membershipExtra/mainFiles/frontEnd/podRouter";
import MembershipExtraLogin from "./membershipExtra/loginPod/loginForm";
import ViewHelpFrontEnd from "./viewHelp/frontEnd/podRouter";
import AppRequestQuoteFrontEnd from "./appRequestQuote/frontEnd/files/quoteSystem";
import OnlinePaymentsFrontEnd from "./viewHelp/onlinePayments/frontEnd/files/controller";
import CalendarFrontEnd from "./calendar/frontEnd/podRouter";
import PlannerFrontEnd from "./planner/frontEnd/podRouter";
import PodcastsFrontEnd from "./podCasts/frontEnd/podRouter";
import BlogsFrontEnd from "./blogs/frontEnd/podRouter";
import ReviewsFrontEnd from "./reviews/frontEnd/podRouter";
import AnimationsFrontEnd from "./animations/frontEnd/podRouter";
import FootballAPIFrontEnd from "./footballAPI/frontEnd/files/controller";

function EnvironmentPodsMap(props) {
    return (
        <div>
            {props.podCode == "loginForm" && <HVSAdminLoginControl />}
            {props.podCode == "CPOD_MEMBEREXTRA_FREND" && <MembershipExtraLogin />}

            {/* ADMIN */}
            {props.podCode == "CPOD_WEBSITEQUOTE_ADMIN" && <WebsiteQuoteAdmin />}
            {props.podCode == "CPOD_VIEWHELP_ADMIN" && <ViewHelp_HelpDesk />}
            {props.podCode == "CPOD_APPREQUESTQUOTE_ADMIN" && <AppRequestQuoteAdmin />}
            {props.podCode == "CPOD_VIEWHELP_PAYMENTS_ADMIN" && <ViewHelp_OnlinePayments />}
            {props.podCode == "CPOD_CALENDAR_ADMIN" && <CalendarAdmin />}
            {props.podCode == "CPOD_PLANNER_ADMIN" && <PlannerAdmin />}
            {props.podCode == "CPOD_PODCASTS_ADMIN" && <PodCastsAdmin />}
            {props.podCode == "CPOD_BLOGS_ADMIN" && <BlogsAdmin />}
            {props.podCode == "CPOD_FOOTBALLAPI_ADMIN" && <FootballAPIAdmin />}
            {props.podCode == "CPOD_PHOTOGALLERY_ADMIN" && <PhotoGalleryAdmin />}

            {/* FRONTEND */}
            {props.podCode == "CPOD_WEBSITEQUOTE_FREND" && <WebsiteQuoteFrontEnd />}
            {props.podCode == "CPOD_VIEWHELP_FREND" && <ViewHelpFrontEnd />}
            {props.podCode == "CPOD_APPREQUESTQUOTE_FREND" && <AppRequestQuoteFrontEnd />}
            {props.podCode == "CPOD_VIEWHELP_PAYMENTS_FEND" && <OnlinePaymentsFrontEnd />}
            {props.podCode == "CPOD_CALENDAR_FREND" && <CalendarFrontEnd />}
            {props.podCode == "CPOD_PLANNER_FREND" && <PlannerFrontEnd />}
            {props.podCode == "CPOD_PODCASTS_FREND" && <PodcastsFrontEnd />}
            {props.podCode == "CPOD_BLOGS_FREND" && <BlogsFrontEnd uuid={props.addInfo} />}
            {props.podCode == "CPOD_REVIEWS_FREND" && <ReviewsFrontEnd />}
            {props.podCode == "CPOD_ANIMATIONS_FREND" && <AnimationsFrontEnd />}
            {props.podCode == "CPOD_FOOTBALLAPI_FREND" && <FootballAPIFrontEnd />}

            {props.podCode == "membership" && <MembershipExtra />}
        </div>
    );
}

export function EnvironmentPodsMap_PageViewer(props) {
    return null;
}

export function SegmentedMenus(code) {
    return null;
}

export default EnvironmentPodsMap;
